// MG Product Swatches export: page Swatch Picker sections
window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
window.MG_SWATCH_SETS["Colors-WNK16ctop"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24071744848006,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/0cadee7fdd5d432e839c78deabaa46ae.thumbnail.0000000000.jpg?v=1680284213&width=400",
          "product_url": "/products/countertopkit_white-wash_m_tripletique",
          "product_id": 6750408212614,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_white-wash_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 28891681423494,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-WOAK-TPLQM-BoxBNI.png?v=1774444859&width=400",
          "product_url": "/products/countertopkit_white-oak_m_tripletique",
          "product_id": 6982979944582,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_white-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29528536776838,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-FOAK-TPLQM-wBox-Countertop.png?v=1777392459&width=400",
          "product_url": "/products/countertopkit_french-oak_m_tripletique",
          "product_id": 6730509123718,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_french-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 28241141301382,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-OneKit3Finishes_bb0688bf-e648-497f-918e-3b96f9a6c3a0.jpg?v=1774444968&width=400",
          "product_url": "/products/countertopkit_barn-wood_m_tripletique",
          "product_id": 6730504241286,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_barn-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 28891523973254,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-DOAK-TPLQM-BoxBNI.png?v=1774444994&width=400",
          "product_url": "/products/countertopkit_dark-oak_m_tripletique",
          "product_id": 6730506436742,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_dark-oak_m_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 28891640594566,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-SBCH-TPLQM-BoxBNI.png?v=1774444579&width=400",
          "product_url": "/products/countertopkit_sun-bleached_m_tripletique",
          "product_id": 7195724152966,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_sun-bleached_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 28891591639174,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-POAK-TPLQM-BoxBNI.png?v=1774444941&width=400",
          "product_url": "/products/countertopkit_pickled-oak_m_tripletique",
          "product_id": 6750727340166,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_pickled-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26945256161414,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1935740312-857210f3bfbf4e6873d67d1c2fe6868dddabc66b287cd7a26bfed04e93596569-d_295x166_37a358be-e8c4-4499-ab20-d45853e1b38e.jpg?v=1728422425&width=400",
          "product_url": "/products/countertopkit_weathered-wood_m_tripletique",
          "product_id": 6730512302214,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_weathered-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 28891434254470,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-BWAL-TPLQM-BoxBNI.png?v=1774445022&width=400",
          "product_url": "/products/countertopkit_black-walnut_m_tripletique",
          "product_id": 6730472685702,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_black-walnut_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 28891537670278,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-DRIW-TPLQS-BoxBNI.png?v=1774447574&width=400",
          "product_url": "/products/countertopkit_drift-wood_m_tripletique",
          "product_id": 6814280253574,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_drift-wood_m_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 23338447831174,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/1460981693-42de17a24b388df1f340bf2dfbd437f8c5bfdf0861684c0d29a257d4a12c5b14-d_295x166_23fd8e98-09ef-4b2e-995b-e50fc904eaab.jpg?v=1667403474&width=400",
          "product_url": "/products/countertopkit_cedar_m_tripletique",
          "product_id": 6730505945222,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_cedar_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25538260697222,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch--WoodnStain_aaf25751-5987-4fb2-b8a1-0abd8e76588f.jpg?v=1774445235&width=400",
          "product_url": "/products/countertopkit_vintage-cherry_m_tripletique",
          "product_id": 6816500383878,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_vintage-cherry_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 23338459791494,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/1432041120-3cfb84807657c720545ea9e260817f3132794a30f4b252d8a1d8b20be37f113f-d_295x166_53935a4b-354b-4d65-813f-2ec4be910290.jpg?v=1667403834&width=400",
          "product_url": "/products/countertopkit_java_m_tripletique",
          "product_id": 6730503684230,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_java_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26945256161414,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1935740312-857210f3bfbf4e6873d67d1c2fe6868dddabc66b287cd7a26bfed04e93596569-d_295x166_37a358be-e8c4-4499-ab20-d45853e1b38e.jpg?v=1728422425&width=400",
          "product_url": "/products/countertopkit_red-mahogany_m_tripletique",
          "product_id": 6730510172294,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_red-mahogany_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 23338460151942,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/1432041120-3cfb84807657c720545ea9e260817f3132794a30f4b252d8a1d8b20be37f113f-d_295x166_50b692e9-bf46-4797-b2ce-f468738a1512.jpg?v=1667403846&width=400",
          "product_url": "/products/countertopkit_old-oak_m_tripletique",
          "product_id": 6750283759750,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_old-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25538234908806,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatches-OneKit3Finishes_6ac21dec-260b-4ea8-a2bf-e1b8ab73005b.jpg?v=1774445401&width=400",
          "product_url": "/products/countertopkit_pecan_m_tripletique",
          "product_id": 6730509942918,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_pecan_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 23338457301126,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/1432041120-3cfb84807657c720545ea9e260817f3132794a30f4b252d8a1d8b20be37f113f-d_295x166_867b3cb3-6651-4a33-90bf-d0ef90df2a37.jpg?v=1667403749&width=400",
          "product_url": "/products/countertopkit_charcoal_m_tripletique",
          "product_id": 6730506174598,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_charcoal_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29343331385478,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-CBLK-Box-3D-Countertop.png?v=1774447841&width=400",
          "product_url": "/products/countertopkit_classic-black_m_tripletique",
          "product_id": 6816500809862,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_classic-black_m_tripletique",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK32ctop"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29528000954502,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WWSH-TPLQ-Satin-onTable_87fba3bc-b9c7-43b0-a3ad-167dafcc70bc.png?v=1777383130&width=400",
          "product_url": "/products/countertopkit_white-wash_l_tripletique",
          "product_id": 6832735060102,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_white-wash_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29282198093958,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WOAK-TPLQM-wBox-Countertop.png?v=1774445582&width=400",
          "product_url": "/products/countertopkit_white-oak_l_tripletique",
          "product_id": 6982980010118,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_white-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29528589041798,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-FOAK-TPLQM-wBox_9b782636-bb03-4f2a-8cc8-8bd502a815a1.png?v=1777393325&width=400",
          "product_url": "/products/countertopkit_french-oak_l_tripletique",
          "product_id": 6832724902022,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_french-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 28166050939014,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-OneKit3Finishes_b28ff3b2-1cd4-4bf6-bd6c-499f9a442639.jpg?v=1775056607&width=400",
          "product_url": "/products/countertopkit_barn-wood_l_tripletique",
          "product_id": 6832718348422,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_barn-wood_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29282228830342,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DOAK-TPLQM-wBox-Countertop.png?v=1774445752&width=400",
          "product_url": "/products/countertopkit_dark-oak_l_tripletique",
          "product_id": 6832722673798,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_dark-oak_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29282151628934,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-SBCH-TPLQM-wBox-Countertop.png?v=1774445533&width=400",
          "product_url": "/products/countertopkit_sun-bleached_l_tripletique",
          "product_id": 7195724349574,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_sun-bleached_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29282211627142,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-POAK-TPLQM-wBox-Countertop.png?v=1774445660&width=400",
          "product_url": "/products/countertopkit_pickled-oak_l_tripletique",
          "product_id": 6832731062406,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_pickled-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29283088597126,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WETH-TPLQG-wBox-Counertop.png?v=1774446207&width=400",
          "product_url": "/products/countertopkit_weathered-wood_l_tripletique",
          "product_id": 6832734535814,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_weathered-wood_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29282239348870,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BWAL-TPLQM-wBox-Countertop.png?v=1774445781&width=400",
          "product_url": "/products/countertopkit_black-walnut_l_tripletique",
          "product_id": 6832720117894,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_black-walnut_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29283030892678,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DRIW-TPLQS-wBox-Countertop.png?v=1774446164&width=400",
          "product_url": "/products/countertopkit_drift-wood_l_tripletique",
          "product_id": 6832724082822,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_drift-wood_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26945256161414,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1935740312-857210f3bfbf4e6873d67d1c2fe6868dddabc66b287cd7a26bfed04e93596569-d_295x166_37a358be-e8c4-4499-ab20-d45853e1b38e.jpg?v=1728422425&width=400",
          "product_url": "/products/countertopkit_cedar_l_tripletique",
          "product_id": 6832720773254,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_cedar_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25538125365382,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch--WoodnStain_9ac06f66-8a9f-494b-8434-ac76eb779f8b.jpg?v=1774446484&width=400",
          "product_url": "/products/countertopkit_vintage-cherry_l_tripletique",
          "product_id": 6832733028486,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_vintage-cherry_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29283155673222,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-JAVA-TPLQS-wBox-Countertop.png?v=1774446604&width=400",
          "product_url": "/products/countertopkit_java_l_tripletique",
          "product_id": 6832726933638,
          "price": "$229.99",
          "price_num": 229.99,
          "available": false,
          "cta": {
            "href": "/products/countertopkit_java_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29283165634694,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-RMGY-TPLQS-wBox-Countertop.png?v=1774446661&width=400",
          "product_url": "/products/countertopkit_red-mahogany_l_tripletique",
          "product_id": 6832732799110,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_red-mahogany_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29283210821766,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-OOAK-TPLQS-wBox-Countertop.png?v=1774446708&width=400",
          "product_url": "/products/countertopkit_old-oak_l_tripletique",
          "product_id": 6832728473734,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_old-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25538107670662,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch--WoodnStain_f3829521-dd6f-49ba-91fa-f583f6702c2c.jpg?v=1774446754&width=400",
          "product_url": "/products/countertopkit_pecan_l_tripletique",
          "product_id": 6832730341510,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_pecan_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29283110420614,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHAR-TPLQS-wBox-Countertop.png?v=1774446270&width=400",
          "product_url": "/products/countertopkit_charcoal_l_tripletique",
          "product_id": 6832721494150,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_charcoal_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29343411765382,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CBLK-Box-3D-Countertop.png?v=1774449286&width=400",
          "product_url": "/products/countertopkit_classic-black_l_tripletique",
          "product_id": 6832721920134,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_classic-black_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK128ctop"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24071749009542,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/6161161ee7304e47a8615640eae53e54.thumbnail.0000000000.jpg?v=1680284455&width=400",
          "product_url": "/products/woodnfinish_white-wash_xl",
          "product_id": 6829902954630,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-wash_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29238928932998,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WOAK-wBox.png?v=1773252919&width=400",
          "product_url": "/products/woodnfinish_white-oak_xl",
          "product_id": 6982958973062,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_white-oak_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29528353538182,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-FOAK-wBox_21ee1bbb-b85d-423d-907a-f86ba3ebb838.png?v=1777388555&width=400",
          "product_url": "/products/woodnfinish_french-oak_xl",
          "product_id": 6829881098374,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_french-oak_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29238942728326,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BARN-table.png?v=1773253456&width=400",
          "product_url": "/products/woodnfinish_barn-wood_xl",
          "product_id": 6829845053574,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_barn-wood_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29238949019782,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DOAK-wBox.png?v=1773253801&width=400",
          "product_url": "/products/woodnfinish_dark-oak_xl",
          "product_id": 6829877887110,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_dark-oak_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29238913564806,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-SBCH-wBox.png?v=1773252482&width=400",
          "product_url": "/products/woodnfinish_sun-bleached_xl",
          "product_id": 7195719499910,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_sun-bleached_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29238933422214,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-POAK-wBox.png?v=1773253169&width=400",
          "product_url": "/products/woodnfinish_pickled-oak_xl",
          "product_id": 6829888864390,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_pickled-oak_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24937160048774,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WeatheredWoodKit-FB.jpg?v=1773256414&width=400",
          "product_url": "/products/woodnfinish_weathered-wood_xl",
          "product_id": 6829901185158,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_weathered-wood_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29238972842118,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BWAL-wBox.png?v=1773254161&width=400",
          "product_url": "/products/woodnfinish_black-walnut_xl",
          "product_id": 6830627881094,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_black-walnut_xl",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 28806467027078,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-03_6e296d13-6b0b-4a04-8ca7-b08eeef004e8.png?v=1773256101&width=400",
          "product_url": "/products/woodnfinish_drift-wood_xl",
          "product_id": 6829879656582,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_drift-wood_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25539200155782,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Cabinets-_Grained_148d2f97-592d-486b-801f-126857632b14.jpg?v=1773260038&width=400",
          "product_url": "/products/woodnfinish_cedar_xl",
          "product_id": 6829867204742,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_cedar_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29239080222854,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHRY-table.png?v=1773257031&width=400",
          "product_url": "/products/woodnfinish_vintage-cherry_xl",
          "product_id": 6829892599942,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_vintage-cherry_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25539302228102,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Fireplace-Mantle-_Grained_28c5d42d-b7a9-4288-bfaa-fd4105d92062.jpg?v=1773259137&width=400",
          "product_url": "/products/woodnfinish_java_xl",
          "product_id": 6829882310790,
          "price": "$549.99",
          "price_num": 549.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_java_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25539318153350,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Grained_40a13a94-1199-4d0b-9dd2-60bf59b0cf7a.jpg?v=1773260374&width=400",
          "product_url": "/products/woodnfinish_old-oak_xl",
          "product_id": 6829885161606,
          "price": "$549.99",
          "price_num": 549.99,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_old-oak_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25539266183302,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DoubleFrontDoor-_Grained_16d9055f-1d4d-4d71-9884-dba4abbaa2ef.jpg?v=1773260621&width=400",
          "product_url": "/products/woodnfinish_pecan_xl",
          "product_id": 6829885980806,
          "price": "$549.99",
          "price_num": 549.99,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_pecan_xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25539396534406,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Fireplace-Mantle-_Grained_fee38ec6-b3fc-4ae5-a474-9cb07db08cb4.jpg?v=1773245188&width=400",
          "product_url": "/products/woodnfinish_charcoal_l",
          "product_id": 6829905772678,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/woodnfinish_charcoal_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25539241902214,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Grained_07fc878a-88cd-43d5-956d-3a957ae126bd.jpg?v=1773258829&width=400",
          "product_url": "/products/woodnfinish_classic-black_xl",
          "product_id": 6829876904070,
          "price": "$549.99",
          "price_num": 549.99,
          "available": false,
          "cta": {
            "href": "/products/woodnfinish_classic-black_xl",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-SBCH"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-SBCH-TPLQM-BoxBNI.png?v=1774444579&width=400",
          "product_url": "/products/countertopkit_sun-bleached_m_tripletique",
          "product_id": 7195724152966,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_sun-bleached_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-SBCH-TPLQM-wBox-Countertop.png?v=1774445533&width=400",
          "product_url": "/products/countertopkit_sun-bleached_l_tripletique",
          "product_id": 7195724349574,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_sun-bleached_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__mg_product_swatches_G4hXRR-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-WWSH"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-WWSH-TPLQM-wBox-Countertop_52deaa8a-fd9d-48e2-8d1d-81863bca36fe.png?v=1777382945&width=400",
          "product_url": "/products/countertopkit_white-wash_m_tripletique",
          "product_id": 6750408212614,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_white-wash_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WWSH-TPLQM-wBox-Countertop_19bd8a49-ee7f-48cd-aa4c-4904bbb7665a.png?v=1777383118&width=400",
          "product_url": "/products/countertopkit_white-wash_l_tripletique",
          "product_id": 6832735060102,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_white-wash_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_crgpMc-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-WOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-WOAK-TPLQM-BoxBNI.png?v=1774444859&width=400",
          "product_url": "/products/countertopkit_white-oak_m_tripletique",
          "product_id": 6982979944582,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_white-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WOAK-TPLQM-wBox-Countertop.png?v=1774445582&width=400",
          "product_url": "/products/countertopkit_white-oak_l_tripletique",
          "product_id": 6982980010118,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_white-oak_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_GAczKg-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-POAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-POAK-TPLQM-BoxBNI.png?v=1774444941&width=400",
          "product_url": "/products/countertopkit_pickled-oak_m_tripletique",
          "product_id": 6750727340166,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_pickled-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-POAK-TPLQM-wBox-Countertop.png?v=1774445660&width=400",
          "product_url": "/products/countertopkit_pickled-oak_l_tripletique",
          "product_id": 6832731062406,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_pickled-oak_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_UNWmma-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-BARN"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-BARN-TPLQM-wBox-Countertop_d7db590a-586b-46ca-8d82-090fb63fe104.png?v=1777571240&width=400",
          "product_url": "/products/countertopkit_barn-wood_m_tripletique",
          "product_id": 6730504241286,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_barn-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BARN-TPLQM-wBox-Countertop.png?v=1774445690&width=400",
          "product_url": "/products/countertopkit_barn-wood_l_tripletique",
          "product_id": 6832718348422,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_barn-wood_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_z6CcgH-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-DOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-DOAK-TPLQM-BoxBNI.png?v=1774444994&width=400",
          "product_url": "/products/countertopkit_dark-oak_m_tripletique",
          "product_id": 6730506436742,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_dark-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DOAK-TPLQM-wBox-Countertop.png?v=1774445752&width=400",
          "product_url": "/products/countertopkit_dark-oak_l_tripletique",
          "product_id": 6832722673798,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_dark-oak_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_bfWFta-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-BWAL"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-BWAL-TPLQM-BoxBNI.png?v=1774445022&width=400",
          "product_url": "/products/countertopkit_black-walnut_m_tripletique",
          "product_id": 6730472685702,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_black-walnut_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BWAL-TPLQM-wBox-Countertop.png?v=1774445781&width=400",
          "product_url": "/products/countertopkit_black-walnut_l_tripletique",
          "product_id": 6832720117894,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_black-walnut_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_jULa3b-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-FOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-FOAK-TPLQM-wBox-Countertop.png?v=1777392459&width=400",
          "product_url": "/products/countertopkit_french-oak_m_tripletique",
          "product_id": 6730509123718,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_french-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-FOAK-TPLQM-wBox_9b782636-bb03-4f2a-8cc8-8bd502a815a1.png?v=1777393325&width=400",
          "product_url": "/products/countertopkit_french-oak_l_tripletique",
          "product_id": 6832724902022,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_french-oak_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_kii7mh-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-DRIW"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-DRIW-TPLQM-BoxBNI.png?v=1774445130&width=400",
          "product_url": "/products/countertopkit_drift-wood_m_tripletique",
          "product_id": 6814280253574,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_drift-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DRIW-TPLQM-wBox-Countertop.png?v=1774446105&width=400",
          "product_url": "/products/countertopkit_drift-wood_l_tripletique",
          "product_id": 6832724082822,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_drift-wood_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_f4piyA-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-WETH"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-WETH-TPLQM-BoxBNI.png?v=1774445160&width=400",
          "product_url": "/products/countertopkit_weathered-wood_m_tripletique",
          "product_id": 6730512302214,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_weathered-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WETH-TPLQM-wBox-Countertop.png?v=1774446207&width=400",
          "product_url": "/products/countertopkit_weathered-wood_l_tripletique",
          "product_id": 6832734535814,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_weathered-wood_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_wQHLrQ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-CHAR"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-CHAR-TPLQM-BoxBNI.png?v=1774445187&width=400",
          "product_url": "/products/countertopkit_charcoal_m_tripletique",
          "product_id": 6730506174598,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_charcoal_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHAR-TPLQM-wBox-Countertop.png?v=1774446270&width=400",
          "product_url": "/products/countertopkit_charcoal_l_tripletique",
          "product_id": 6832721494150,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_charcoal_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_KUjkUY-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-VCHY"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-VCHY-TPLQM-BoxBNI.png?v=1774445235&width=400",
          "product_url": "/products/countertopkit_vintage-cherry_m_tripletique",
          "product_id": 6816500383878,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_vintage-cherry_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHRY-TPLQM-wBox-Countertop.png?v=1774446484&width=400",
          "product_url": "/products/countertopkit_vintage-cherry_l_tripletique",
          "product_id": 6832733028486,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_vintage-cherry_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_QLcFxq-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-CBLK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-CBLK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-CBLK-TPLQM-BoxBNI.png?v=1774445260&width=400",
          "product_url": "/products/countertopkit_classic-black_m_tripletique",
          "product_id": 6816500809862,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_classic-black_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CBLK-TPLQM-wBox-Countertop.png?v=1774446509&width=400",
          "product_url": "/products/countertopkit_classic-black_l_tripletique",
          "product_id": 6832721920134,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_classic-black_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_4hwAdN-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-JAVA"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-JAVA-TPLQM-BoxBNI.png?v=1774445286&width=400",
          "product_url": "/products/countertopkit_java_m_tripletique",
          "product_id": 6730503684230,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_java_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-JAVA-TPLQM-wBox-Countertop.png?v=1774446604&width=400",
          "product_url": "/products/countertopkit_java_l_tripletique",
          "product_id": 6832726933638,
          "price": "$229.99",
          "price_num": 229.99,
          "available": false,
          "cta": {
            "href": "/products/countertopkit_java_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_RqwkpA-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-RMGY"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-RMGY-TPLQM-BoxBNI.png?v=1774445307&width=400",
          "product_url": "/products/countertopkit_red-mahogany_m_tripletique",
          "product_id": 6730510172294,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_red-mahogany_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-RMGY-TPLQM-wBox-Countertop.png?v=1774446622&width=400",
          "product_url": "/products/countertopkit_red-mahogany_l_tripletique",
          "product_id": 6832732799110,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_red-mahogany_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_hQcdrB-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-CEDR"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-CEDR-TPLQM-BoxBNI.png?v=1774445331&width=400",
          "product_url": "/products/countertopkit_cedar_m_tripletique",
          "product_id": 6730505945222,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_cedar_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CEDR-TPLQM-wBox-Countertop.png?v=1774446678&width=400",
          "product_url": "/products/countertopkit_cedar_l_tripletique",
          "product_id": 6832720773254,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_cedar_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_jw6Y6t-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-OOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-OOAK-TPLQM-BoxBNI.png?v=1774445360&width=400",
          "product_url": "/products/countertopkit_old-oak_m_tripletique",
          "product_id": 6750283759750,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_old-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-OOAK-TPLQM-wBox-Countertop.png?v=1774446708&width=400",
          "product_url": "/products/countertopkit_old-oak_l_tripletique",
          "product_id": 6832728473734,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_old-oak_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_Awb4Jd-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKctop-PECA"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNK-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Kitchen Island Kit",
          "alt": "Kitchen Island Kit",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Countertops-WNK16-PECA-TPLQM-BoxBNI.png?v=1774445401&width=400",
          "product_url": "/products/countertopkit_pecan_m_tripletique",
          "product_id": 6730509942918,
          "price": "$139.99",
          "price_num": 139.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_pecan_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Full Countertops",
          "alt": "Full Countertops",
          "swatch_image_size_percent": "100",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-PECA-TPLQM-wBox-Countertop.png?v=1774446754&width=400",
          "product_url": "/products/countertopkit_pecan_l_tripletique",
          "product_id": 6832730341510,
          "price": "$229.99",
          "price_num": 229.99,
          "available": true,
          "cta": {
            "href": "/products/countertopkit_pecan_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18635990466694__csw_custom_swatch_picker_MKPprH-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Kitchen Island Kit - 50 square feet</li>\n    <li>Full Countertops Kit - 100 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};